import { styled } from '@mui/material/styles';
import { Table, TableCell, TableContainer, TableRow } from '@mui/material';

export const StyledTable = styled(Table)({
  tableLayout: 'fixed',
  height: '100%',
  borderCollapse: 'collapse',
  '& .MuiTableCell-root': {
    borderBottom: '0.3px solid #e0e0e0',
    borderRight: '0.3px solid #e0e0e0',
    padding: '4px 8px',
    height: '60px',
    verticalAlign: 'middle',
    fontSize: '0.875rem',
    '& .MuiTypography-root': {
      fontSize: '0.875rem',
      lineHeight: '1.2',
    },
  },
  '& .MuiTableCell-root:last-child': {
    borderRight: 'none',
  },
});

export const StyledTableContainer = styled(TableContainer)({
  marginBottom: '16px',
  border: '0.3px solid #e0e0e0',
  '& .MuiTable-root': {
    borderCollapse: 'collapse',
    '& .MuiTableCell-root': {
      height: '30px',
      padding: '4px 8px',
    },
  },
});

export const StyledTableCell = styled(TableCell)({
  borderBottom: '0.3px solid #e0e0e0',
  borderRight: '0.3px solid #e0e0e0',
  padding: '4px 8px',
  verticalAlign: 'middle',
  height: '50px',
  fontSize: '0.875rem',
  '& .MuiTypography-root': {
    fontSize: '0.875rem',
    lineHeight: '1.2',
  },
});

export const StyledTableHeaderCell = styled(TableCell)({
  backgroundColor: '#f5f5f5',
  fontWeight: 'bold',
  borderBottom: '0.3px solid #e0e0e0',
  borderRight: '0.3px solid #e0e0e0',
  padding: '4px 8px',
  textAlign: 'center',
  verticalAlign: 'middle',
  height: '40px',
  fontSize: '0.875rem',
});

export const StyledTableRow = styled(TableRow)({
  '&:last-child td, &:last-child th': {
    borderBottom: '0.3px solid #e0e0e0',
  },
});


